import { cn, Label, Link, Paragraph } from '@quickmd-llc/design-system'
import { type ReactNode } from 'react'
import { MEDICATIONS_PAGE_PATH } from 'utils/constants'

/** The building blocks of the guide's copy in `homeDeliveryGuideSections`. */

const bodyClassName = cn('text-text-medium')

export const Body = ({ children }: { children: ReactNode }) => (
  <Paragraph size='xs' className={bodyClassName}>
    {children}
  </Paragraph>
)

export const Strong = ({ children }: { children: ReactNode }) => <strong className='font-semibold'>{children}</strong>

export const MedicationsLink = () => (
  <Link to={MEDICATIONS_PAGE_PATH} target='_blank' rel='noopener noreferrer' size='sm'>
    Medications section
  </Link>
)

const PRICES = [
  { quantity: 15, tablet: '$29', film: '$49' },
  { quantity: 30, tablet: '$59', film: '$89' },
  { quantity: 45, tablet: '$64', film: '$109' },
  { quantity: 60, tablet: '$69', film: '$129' },
  { quantity: 75, tablet: '$74', film: '$149' },
  { quantity: 90, tablet: '$79', film: '$169' },
] as const

const cellClassName = cn('border-r border-border-medium p-sp-1 text-left align-middle text-text-dark last:border-r-0')

/** Cash prices for buprenorphine-naloxone (8-2 mg), shown under "What it costs." and the MOUD section. */
export const PriceTable = ({ caption }: { caption: string }) => (
  <div className='overflow-clip rounded-lg border border-border-medium'>
    <table className='w-full table-fixed border-collapse'>
      <caption className='sr-only'>{caption}</caption>
      <thead>
        <tr>
          {['Quantity', 'Tablet (8-2 mg)', 'Film (8-2 mg)'].map((heading) => (
            <th key={heading} scope='col' className={cellClassName}>
              <Label size='sm'>{heading}</Label>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {PRICES.map(({ quantity, tablet, film }) => (
          <tr key={quantity} className='border-t border-border-medium'>
            {[quantity, tablet, film].map((value) => (
              <td key={value} className={cellClassName}>
                <Paragraph size='xs' className='text-inherit'>
                  {value}
                </Paragraph>
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)
